import { parse } from "cookie-es";
import { watchLeagueCookie } from "@/lib/leagues/watch-types";
import { readWatchEntry } from "./watch-entry.data";

export function getStoredWatchLeague() {
  return parse(document.cookie)[watchLeagueCookie] ?? null;
}

export function getWatchEntry({
  selection,
  signal,
}: {
  selection: {
    leagueId: string | null;
    stored: string | null;
    globalKiosk: boolean;
  };
  signal?: AbortSignal | undefined;
}) {
  return readWatchEntry({ selection, signal });
}
